import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { MemberValuesFragment } from './member.fragments';

export const GET_ACCOUNT_ANNUALS = gql`
  query GetAccountAnnuals($input: AccountMembersInput!) {
    getAccountAnnuals(input: $input) {
      count
      results {
        ...memberValues
      }
    }
  }
  ${MemberValuesFragment}
`;

export function useGetAccountAnnuals({
  account_id,
  year,
  page,
  limit,
  queryString,
  ticket_id,
  division,
  start_date,
  end_date,
}) {
  return useQuery(GET_ACCOUNT_ANNUALS, {
    variables: {
      input: {
        account_id,
        year,
        ...(page ? { page: String(page) } : null),
        ...(limit ? { limit: String(limit) } : null),
        ...(queryString ? { queryString } : null),
        ...(ticket_id ? { ticket_id } : null),
        ...(division ? { division } : null),
        ...(start_date ? { start_date } : null),
        ...(end_date ? { end_date } : null),
      },
    },
    skip: !account_id || !year,
    fetchPolicy: 'cache-and-network',
  });
}
